import { defineRecipe } from '@chakra-ui/react';
import { Space } from '../../types';

/** A single 16px inline inset and a 60ch prose width, where stock's container widens the inset responsively
 * (24px md, 32px lg) and the width to 8xl. */
export const containerRecipe = defineRecipe({
  base: {
    px: Space.SPACE_4,
    maxW: '60ch',
  },
});
